import React, { useState } from 'react';
import { Link } from '@this/shared/ui/navigations/link';
import { Input } from '@this/shared/ui/inputs/input';
import { Button } from '@this/shared/ui/inputs/button';
import { Alert } from '@this/shared/ui/feedbacks/alert';
import { createTheme } from '@this/constants/themes';

interface UserPasswordResetBlueFormProps {
  isPasswordExpired: boolean;
  navigateToBack: () => void;
  resetPassword: (email: string) => Promise<boolean>;
  serviceId: number;
}

enum UserPasswordResetFormResultType {
  SUCCESS = 'success',
  FAIL = 'fail'
}

const UserPasswordResetBlueForm: React.FC<UserPasswordResetBlueFormProps> = ({
  isPasswordExpired,
  navigateToBack,
  resetPassword,
  serviceId
}) => {
  const [email, setEmail] = useState('');
  const [result, setResult] = useState<{ type: UserPasswordResetFormResultType; message: string } | undefined>();

  // テーマを取得
  const theme = createTheme(serviceId);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const success = await resetPassword(email);
    if (success) {
      setResult({
        type: UserPasswordResetFormResultType.SUCCESS,
        message: 'リセット用のリンクをメールで送信しました'
      });
      setEmail('');
      return;
    }
    setResult({
      type: UserPasswordResetFormResultType.FAIL,
      message: '通信環境が不安定です。時間をおいてもう一度お試しください。'
    });
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', gap: '19px', alignItems: 'flex-start', width: '100%' }}
    >
      {/* ロゴ */}
      <div style={{ height: '36.585px', width: '225.769px', position: 'relative', flexShrink: 0 }}>
        <img
          alt={theme.serviceName}
          src={theme.signInBodyLogoPath}
          style={{
            position: 'absolute',
            inset: 0,
            maxWidth: 'none',
            objectFit: 'cover',
            objectPosition: '50% 50%',
            pointerEvents: 'none',
            width: '100%',
            height: '100%'
          }}
        />
      </div>

      {/* 結果メッセージ */}
      {result && (
        <Alert
          variant={result.type === UserPasswordResetFormResultType.SUCCESS ? 'success' : 'danger'}
          style={{ marginBottom: '16px', width: '100%' }}
        >
          {result.message}
        </Alert>
      )}

      {/* パスワード期限切れメッセージ */}
      {isPasswordExpired && (
        <Alert variant="warning" style={{ marginBottom: '16px', width: '100%' }}>
          パスワードの有効期限が過ぎました。
          <br />
          メールアドレスを入力してパスワードを再設定してください。
        </Alert>
      )}

      {/* メールアドレスラベル */}
      <div
        style={{
          fontFamily: "'Inter', 'Noto Sans JP', sans-serif",
          fontWeight: 500,
          fontSize: '14px',
          color: '#555555',
          width: '100%'
        }}
      >
        メールアドレス
      </div>

      {/* フォーム */}
      <form
        onSubmit={handleSubmit}
        style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '19px' }}
      >
        {/* メールアドレス入力 */}
        <div style={{ height: '48.474px', width: '100%', position: 'relative' }}>
          <Input
            type="email"
            name="email"
            placeholder=""
            value={email}
            onChange={e => setEmail(e.target.value)}
            fullWidth
            style={{
              height: '100%',
              border: '1px solid #0080cb'
            }}
          />
        </div>

        {/* パスワード再設定ボタン */}
        <Button type="submit" disabled={!email} fullWidth style={{ height: '48.474px' }}>
          パスワード再設定
        </Button>
      </form>

      {/* 戻るリンク */}
      {!isPasswordExpired && (
        <div style={{ width: '100%', textAlign: 'right' }}>
          <Link size="small" onClick={navigateToBack}>
            戻る
          </Link>
        </div>
      )}
    </div>
  );
};

export default UserPasswordResetBlueForm;
